// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  intentId: __t.string().name("intent_id"),
  characterId: __t.string().name("character_id"),
  instanceId: __t.string().name("instance_id"),
  tickTarget: __t.i64().name("tick_target"),
  payloadJson: __t.string().name("payload_json"),
  validationStatus: __t.string().name("validation_status"),
  resolvedTick: __t.i64().name("resolved_tick"),
  receivedAt: __t.timestamp().name("received_at"),
});
